import { render } from "./PreviewGamesHomePage.vue?vue&type=template&id=3b542e7c"
import script from "./PreviewGamesHomePage.vue?vue&type=script&lang=js"
export * from "./PreviewGamesHomePage.vue?vue&type=script&lang=js"

import "./PreviewGamesHomePage.vue?vue&type=style&index=0&id=3b542e7c&lang=scss"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__